import { useState } from "react";
import { toast } from "sonner";
import { RefreshCw } from "lucide-react";
import { useOrders } from "@/lib/OrdersContext";
import { PageHeader } from "@/components/PageHeader";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function AjustesPage() {
  const { workshopName, setWorkshopName, branchName, setBranchName, connected, orders, reload } = useOrders();
  const [name, setName] = useState(workshopName);
  const [branch, setBranch] = useState(branchName);

  const save = (e) => {
    e.preventDefault();
    setWorkshopName(name.trim() || "Taller Pro");
    setBranchName(branch.trim() || "Sucursal Principal");
    toast.success("Ajustes guardados");
  };

  return (
    <>
      <PageHeader title="Ajustes" subtitle="Datos del taller y estado de la sincronización" />
      <div className="grid gap-6 lg:grid-cols-2">
        <form onSubmit={save} className="space-y-4 rounded-xl border border-white/5 bg-[#111114] p-6">
          <h2 className="font-display text-base font-semibold md:text-lg">Taller</h2>
          <div className="space-y-1.5">
            <Label htmlFor="wname">Nombre del taller</Label>
            <Input id="wname" data-testid="settings-workshop-name-input" value={name} onChange={(e) => setName(e.target.value)} />
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="bname">Nombre de la sucursal</Label>
            <Input id="bname" data-testid="settings-branch-name-input" value={branch} onChange={(e) => setBranch(e.target.value)} />
          </div>
          <button data-testid="settings-save-btn" className="rounded-lg bg-[var(--gold)] px-5 py-2.5 text-sm font-bold text-black hover:bg-amber-400">Guardar</button>
        </form>
        <div className="space-y-4 rounded-xl border border-white/5 bg-[#111114] p-6">
          <h2 className="font-display text-base font-semibold md:text-lg">Base de datos</h2>
          <p className="text-sm text-zinc-400">Tabla <code className="text-[var(--gold)]">ordenes_reparacion</code> en Supabase, con actualización en tiempo real.</p>
          <p data-testid="settings-connection-status" className="text-sm">
            Estado: <span className={connected ? "text-emerald-400" : "text-zinc-400"}>{connected ? "Conectado" : connected === false ? "Sin respuesta" : "Comprobando…"}</span>
            <span className="ml-3 text-zinc-500">· {orders.length} órdenes visibles</span>
          </p>
          <button data-testid="settings-reload-btn" onClick={reload} className="flex items-center gap-2 rounded-lg border border-white/10 px-4 py-2 text-sm hover:border-[var(--gold)] hover:text-[var(--gold)]">
            <RefreshCw className="h-4 w-4" /> Sincronizar ahora
          </button>
        </div>
      </div>
    </>
  );
}
